import request from 'crm/utils/request'
import api from 'crm/common/api/group-bulk'
import {format} from 'utils'
import qs from 'qs'

// 群发列表
export async function getBulkList(payload) {
    return request(`${format(api.getBulkList.url)}?${qs.stringify(payload.params)}`)
}

// 群发明细列表
export async function getBulkDetails(payload) {
    return request(
        `${format(api.getBulkDetails.url, {id: payload.id})}?${qs.stringify(payload.params)}`,
    )
}

// 创建群发
export async function createBulk(payload) {
    return request(api.createBulk.url, {
        method: api.createBulk.type,
        body: payload.body,
    })
}

// 群发摘要
export async function getBulkSummary(payload) {
    return request(format(api.getBulkSummary.url, {id: payload.id}))
}

// 获取客户管理的客户
export async function getCustomers(params) {
    return request(api.getCustomers.url, {
        method: api.getCustomers.type,
        body: params,
    })
}

// 重发详情
export async function getRepeatDetails(payload) {
    return request(format(api.getRepeatDetails.url, {id: payload.id}))
}

// 取消群发
export async function cancelSendBulk(payload) {
    return request(format(api.cancelSendBulk.url, {id: payload.id}), {
        method: api.cancelSendBulk.type,
        body: payload.body,
    })
}

// 计算过滤后的群发客户数量
export async function getFilterCustomerCount(payload) {
    return request(api.getFilterCustomerCount.url, {
        method: api.getFilterCustomerCount.type,
        body: payload.body,
    })
}

export async function exportData(payload) {
    return request(format(api.exportData.url, {id: payload.id}), {
        method: api.exportData.type,
        body: {},
    })
}
